import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import Div from 'src/components/atomic/atom/Div'
import { GnbListType } from 'src/types/types'
import { COLOR } from 'src/constants/colors'
import { RootState } from 'src/store/store'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import CustomNavLink from 'src/components/atomic/atom/CustomNavLink'
import useMatchHook from 'src/hooks/useMatch.hook'
import usePromptHook from 'src/hooks/usePrompt.hook'

const PcGnb = () => {
  const { setMediaStyle } = useMediaQueryHook()
  const { t } = useTranslation()
  const { BatteryInfo, SvgName } = useAppSelector((state: RootState) => state.isBattery)
  const {
    m_setting,
    m_explorer_detail,
    m_explorer,
    m_explorer_delete,
    m_home,
    m_camera,
    m_location,
  } = useMatchHook()
  const { CameraStatus } = useAppSelector((state: RootState) => state.CameraPage)
  // 영상통화 실행중일때
  const { PromptNavLinkHandler } = usePromptHook(CameraStatus !== 'default')

  const PcGnbList: GnbListType[] = [
    {
      text: t('MENU.HOME', { defaultValue: 'Home' }) as string,
      svg: m_home ? 'home_active' : 'home',
      size: { width: '40', height: '40' },
      path: '/home',
      matchPath: m_home,
      className: 'menu_home',
    },
    {
      text: t('MENU.LOCATE_DEVICE', { defaultValue: 'Locate Device' }) as string,
      svg: m_location ? 'locate_active' : 'locate',
      size: { width: '40', height: '40' },
      path: '/location',
      matchPath: m_location,
      className: 'menu_locate_device',
    },
    {
      text: t('MENU.FILE_EXPLORER', { defaultValue: 'File Explorer' }) as string,
      svg: m_explorer || m_explorer_detail || m_explorer_delete ? 'file_active' : 'file_grey',
      size: { width: '40', height: '40' },
      path: '/explorer',
      matchPath: m_explorer || m_explorer_detail || m_explorer_delete,
      className: 'menu_file_explorer',
    },
    {
      text: t('MENU.VIDEO_CALL', { defaultValue: 'VideoCall' }) as string,
      svg: m_camera ? 'video_call_active' : 'video_call',
      size: { width: '40', height: '40' },
      path: '/camera',
      matchPath: m_camera,
      className: 'menu_video_call',
    },
    {
      text: t('MENU.SETTING', { defaultValue: 'Setting' }) as string,
      svg: m_setting ? 'setting_active' : 'setting',
      size: { width: '40', height: '40' },
      path: '/setting',
      matchPath: m_setting,
      className: 'menu_setting',
    },
  ]

  const settingItem = PcGnbList.pop()
  return (
    <>
      <Div
        display={setMediaStyle('block', 'none', 'none')}
        width={'80px'}
        $min_width={'80px'}
        height={'100dvh'}
        $min_height={'945px'}
        $bgColor={COLOR.white}
        style={{ filter: ' drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.1))' }}
      >
        <Div $bgColor={COLOR.white} style={{ flexDirection: 'column' }}>
          <Div
            display={'flex'}
            width={'100%'}
            height={'100px'}
            $flex_direction={'column'}
            $justify_content={'center'}
          >
            <Svg name={'logo'} width={'32'} height={'32'} />
          </Div>
          {PcGnbList.map((element: GnbListType) => (
            <CustomNavLink
              key={element.text}
              link={element.path}
              className={element.className}
              display={'flex'}
              width={'100%'}
              height={'100px'}
              $flex_direction={'column'}
              $justify_content={'center'}
              $border_radius={element.matchPath ? '0 12px 12px 0' : ''}
              onClick={(e: MouseEvent<HTMLAnchorElement>) => PromptNavLinkHandler(e, element.path)}
            >
              <Svg name={element?.svg} width={element.size.width} height={element.size.height} />
              <Span
                option={'tiny'}
                width={'80px'}
                color={element.matchPath ? COLOR.white : COLOR.black40}
              >
                {element.text}
              </Span>
            </CustomNavLink>
          ))}
        </Div>
        <Div $bgColor={COLOR.white} width={'100%'} style={{ position: 'absolute', bottom: 0 }}>
          <Div
            width={'100%'}
            height={'100px'}
            display={'flex'}
            $flex_direction={'column'}
            $justify_content={'center'}
          >
            <Svg name={SvgName.pc} />
            <Span option={'tiny'} $margin={'11px 0 0'}>
              {typeof BatteryInfo === 'number' && BatteryInfo + '%'}
            </Span>
          </Div>
          {settingItem && (
            <CustomNavLink
              width={'100%'}
              height={'100px'}
              className={settingItem.className}
              link={settingItem.path}
              $border_radius={m_setting ? '0 12px 12px 0' : ''}
              onClick={(e: MouseEvent<HTMLAnchorElement>) =>
                PromptNavLinkHandler(e, settingItem.path)
              }
              display={'flex'}
              $flex_direction={'column'}
              $justify_content={'center'}
            >
              <Svg
                name={settingItem?.svg}
                width={settingItem.size.width}
                height={settingItem.size.height}
              />
              <Span option={'tiny'} color={m_setting ? COLOR.white : COLOR.black40}>
                {settingItem?.text}
              </Span>
            </CustomNavLink>
          )}
        </Div>
      </Div>
    </>
  )
}
export default PcGnb
